// TODO [HSoC]: To be replaced by BE response
export const UseCases = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  SMART_CRM: 'smart-crm'
};
export const AvailableUseCases = Object.values(UseCases);
export const useCasesQueryParamKey = 'useCases';

// TODO [HSoC]: Will be queried from BE as user selects use case
export const FEATURE_LIST = ['Help Desk', 'Customer Success', 'Knowledge Base', 'Feedback Surveys', 'Health Scores', 'SLAs'];